<template>
  <div class="company-address-book-wrapper">
    <h2 class="title">
      Address Book
    </h2>
    <p class="content">
      Truckl automatically keeps track of every location you ship to and from to save you time when setting up new transactions.
      <br/>
      But you can also manually add locations, contacts or carriers to your address book so they can be available during transaction setup.
    </p>

    <div class="card">
      <b-tabs v-model="activeTab" position="is-centered" type="is-toggle" expanded>

      <b-tab-item label="Locations">
        <location-list @selected="createTransaction" />
      </b-tab-item>

      <b-tab-item label="Location Contacts">
        <contacts-list/>
      </b-tab-item>

      <b-tab-item label="Carriers">
        <carrier-list />
      </b-tab-item>

    </b-tabs>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import LocationList from '@/components/RolodexLocationList'
import ContactsList from '@/components/RolodexContactsList'
import CarrierList from '@/components/RolodexCarrierList'
export default {
  name: 'AddressBook',
  components: {
    LocationList,
    ContactsList,
    CarrierList
  },

  data() {
    return {
      activeTab: 0
    }
  },

  methods: {
    ...mapMutations({ setPreselectedLocation: 'SET_PRESELECTED_SHIP_TO' }),
    createTransaction(companyRolodexJobLocation) {
      this.setPreselectedLocation(companyRolodexJobLocation)
      this.$router.push({ name: 'create-transaction' })
    }
  }
}
</script>

<style scoped lang="scss">
.company-address-book-wrapper::after {
  // TODO: this would be great as a mix-in
  content: '';
  background-image: url('../../assets/backgrounds/shutterstock_465284084.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.4;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  z-index: -1;
}
</style>
